import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import {
  ShieldCheck,
  Heart,
  Medal,
  ThumbsUp,
  Home,
  MapPin,
  Clock,
} from "lucide-react";

const trustPoints = [
  {
    icon: ShieldCheck,
    title: "Fully Licensed & Insured",
  },
  {
    icon: Heart,
    title: "Family-Owned & Operated",
  },
  {
    icon: Medal,
    title: "25+ Years of Experience",
  },
  {
    icon: ThumbsUp,
    title: "100% Satisfaction Guarantee",
  },
  {
    icon: Home,
    title: "Residential & Commercial",
  },
  {
    icon: MapPin,
    title: "Serving All of NWA",
  },
  {
    icon: Clock,
    title: "Reliable, Honest, On-Time",
  },
];

const TrustSignals = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="section-padding bg-secondary">
      <div className="container-custom mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Why Does <span className="text-primary">NWA</span> Trust Us?
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {trustPoints.map((point, index) => (
            <motion.div
              key={point.title}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={isInView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.4, delay: index * 0.08 }}
              className="group bg-card p-6 rounded-lg border border-border hover:border-primary/50 hover:shadow-md transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 bg-primary/10 rounded-full flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                <point.icon className="h-7 w-7 text-primary" />
              </div>
              <p className="font-semibold text-foreground text-sm md:text-base">
                {point.title}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;
